module.exports = __webpack_public_path__ + "img/scout-4.e3ad2bb3.jpg";